export const heroData = {
  titleLine1: '91在线视频',
  titleLine2: '随时随地·畅享精彩',
  description: '官方最新入口地址实时更新，移动端APP一键下载，海量视频内容等你来发现。安全、稳定、流畅的在线视频观看体验。',
  ctaText: '立即访问',
  ctaLink: '/#announcement',
  secondaryCtaText: 'APP下载',
  secondaryCtaLink: '/#download',
};

export const announcements = [
  {
    id: 1,
    date: '2026-07-07',
    title: '官网最新入口地址更新通知',
    description: '为保障用户访问体验，我们已更新最新官网入口地址。请收藏本页面获取实时更新的访问链接，确保随时畅享精彩内容。',
    url: 'https://www.91zaixianshipin.com',
    badge: '最新',
  },
  {
    id: 2,
    date: '2026-07-05',
    title: '移动端APP v3.8.0版本正式发布',
    description: '全新UI界面升级，播放体验大幅优化，新增离线缓存与画质增强功能。立即下载体验更流畅的视频观看服务。',
    badge: '推荐',
  },
  {
    id: 3,
    date: '2026-07-01',
    title: '服务器维护完成公告',
    description: '为提升服务稳定性，我们已完成服务器全面升级维护。访问速度提升40%，为用户带来更流畅的在线视频观看体验。',
    badge: '公告',
  },
];

export const downloadInfo = {
  title: '随时随地 想看就看',
  subtitle: '支持 iOS / Android 双平台',
  description: '扫描二维码或点击下方按钮下载91在线视频APP，享受高清流畅的移动观影体验。支持离线缓存、画质切换、倍速播放等丰富功能。',
  iosLink: '#',
  androidLink: '#',
};

export const featuredCategories = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '热门精选',
    description: '全网热播视频一网打尽，每日实时更新热门榜单，紧跟潮流不落伍。',
    link: '/category/remen',
    color: 'accent',
  },
  {
    id: 2,
    icon: 'ri-movie-2-line',
    title: '电影大片',
    description: '海量高清电影片库，涵盖动作、喜剧、爱情、科幻等全类型，应有尽有。',
    link: '/category/dianying',
    color: 'primary',
  },
  {
    id: 3,
    icon: 'ri-tv-2-line',
    title: '电视剧集',
    description: '热门电视剧全集收录，国产剧、韩剧、美剧、日剧等一应俱全，追剧首选。',
    link: '/category/dianshiju',
    color: 'secondary',
  },
  {
    id: 4,
    icon: 'ri-live-line',
    title: '综艺娱乐',
    description: '热门综艺节目实时更新，音乐、真人秀、脱口秀等精彩内容不间断放送。',
    link: '/category/zongyi',
    color: 'accent',
  },
  {
    id: 5,
    icon: 'ri-ancient-gate-line',
    title: '动漫动画',
    description: '热血、搞笑、治愈、悬疑各类动漫一网打尽，日漫国漫全收录，二次元乐园。',
    link: '/category/dongman',
    color: 'primary',
  },
  {
    id: 6,
    icon: 'ri-smartphone-line',
    title: '短视频',
    description: '精选优质短视频内容，搞笑段子、生活妙招、知识科普，碎片时间轻松看。',
    link: '/category/duanshipin',
    color: 'secondary',
  },
];

export const hotVideos = [
  {
    id: 1,
    title: '年度最佳悬疑大片《暗夜追踪》全网首播',
    category: '电影',
    description: '豆瓣评分8.9，年度必看悬疑力作，反转烧脑不容错过。',
    imageSeq: 'hot-video-01',
    imageQuery: 'Cinematic%20movie%20poster%20with%20dark%20noir%20aesthetic%2C%20mysterious%20silhouette%20against%20city%20nightscape%2C%20dramatic%20lighting%20with%20warm%20amber%20tones%2C%20film%20grain%20texture%2C%20professional%20movie%20poster%20style%2C%20clean%20composition',
  },
  {
    id: 2,
    title: '热门都市剧《繁华之下》第三季火热更新',
    category: '剧集',
    description: '全网播放量突破50亿，都市情感大戏持续热播中。',
    imageSeq: 'hot-video-02',
    imageQuery: 'Modern%20urban%20drama%20series%20poster%20with%20city%20skyline%20at%20sunset%2C%20warm%20golden%20light%2C%20elegant%20aesthetic%2C%20emotional%20atmosphere%2C%20professional%20drama%20series%20key%20visual%2C%20soft%20bokeh%20background',
  },
  {
    id: 3,
    title: '现象级综艺《欢乐大本营》最新季回归',
    category: '综艺',
    description: '原班人马全新出发，笑点密集，每周五晚准时更新。',
    imageSeq: 'hot-video-03',
    imageQuery: 'Colorful%20variety%20show%20poster%20with%20vibrant%20stage%20lights%2C%20cheerful%20atmosphere%2C%20entertainment%20show%20aesthetic%2C%20bright%20colorful%20spotlights%2C%20festive%20mood%2C%20clean%20professional%20composition',
  },
];

export const testimonials = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20young%20man%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20simple%20lighting%2C%20corporate%20style&width=96&height=96&seq=avatar-01&orientation=squarish',
    name: '张先生',
    role: '资深用户 · 使用3年',
    content: '91在线视频真的非常方便，资源更新快，画质清晰流畅。无论是追剧还是看电影，体验都很好。特别推荐给喜欢在线看视频的朋友们。',
    rating: 5,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20young%20woman%2C%20clean%20white%20background%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20modern%20style&width=96&height=96&seq=avatar-02&orientation=squarish',
    name: '李女士',
    role: 'VIP会员 · 使用2年',
    content: '作为重度追剧用户，91的视频库真的是太全了！APP做得也很好用，离线缓存功能出差时特别实用。',
    rating: 5,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20middle%20aged%20man%2C%20clean%20white%20background%2C%20confident%20look%2C%20business%20style%2C%20soft%20lighting&width=96&height=96&seq=avatar-03&orientation=squarish',
    name: '王先生',
    role: '高级用户 · 使用4年',
    content: '从网站到APP，91一直在进步。更新及时，入口稳定，客服响应也很快。会一直支持下去。',
    rating: 5,
  },
];

export const latestArticles = [
  {
    id: 1,
    slug: 'xiazai-jiaocheng-2026',
    title: '91在线视频APP下载安装完整教程（2026最新版）',
    excerpt: '本文详细介绍91在线视频APP在iOS和Android设备上的下载安装步骤，以及常见问题排查方法，帮助用户快速完成APP安装。',
    date: '2026-07-06',
    category: '使用教程',
    imageSeq: 'article-01',
    imageQuery: 'Clean%20modern%20smartphone%20showing%20video%20app%20interface%2C%20minimalist%20tech%20setup%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography%2C%20soft%20shadows%2C%20neutral%20background',
  },
  {
    id: 2,
    slug: 'vip-gongneng-jieshao',
    title: '91在线视频VIP会员权益全面解析',
    excerpt: '详细了解VIP会员专属权益：无广告观看、超清画质、离线缓存、专属客服等内容，助你做出最佳选择。',
    date: '2026-07-04',
    category: '功能更新',
    imageSeq: 'article-02',
    imageQuery: 'Premium%20membership%20concept%20with%20elegant%20gold%20accents%2C%20luxury%20lifestyle%20aesthetic%2C%20dark%20background%20with%20warm%20highlights%2C%20sophisticated%20visual%2C%20clean%20composition',
  },
  {
    id: 3,
    slug: 'xinpian-shangxian-7yue',
    title: '2026年7月最新上线影片清单',
    excerpt: '本月多部热门大片和电视剧陆续上线，包括多部豆瓣高分作品。快来看看有没有你期待的内容吧！',
    date: '2026-07-03',
    category: '内容推荐',
    imageSeq: 'article-03',
    imageQuery: 'Film%20reel%20and%20cinema%20concept%2C%20artistic%20movie%20themed%20still%20life%2C%20warm%20vintage%20tones%2C%20creative%20composition%2C%20soft%20dramatic%20lighting%2C%20cinematography%20aesthetic',
  },
  {
    id: 4,
    slug: 'anquan-fangwen-zhinan',
    title: '91在线视频安全访问指南',
    excerpt: '为了保障您的账号和隐私安全，请务必通过官方渠道访问91在线视频。本文详细说明安全访问的注意事项和常见问题。',
    date: '2026-07-01',
    category: '安全公告',
    imageSeq: 'article-04',
    imageQuery: 'Cyber%20security%20concept%20with%20shield%20and%20lock%20symbols%2C%20clean%20modern%20design%2C%20professional%20tech%20aesthetic%2C%20blue%20holographic%20elements%20on%20dark%20background%2C%20minimalist%20style',
  },
];